import { render, staticRenderFns } from "./Metadata.vue?vue&type=template&id=21f13a35&scoped=true"
import script from "./Metadata.vue?vue&type=script&lang=js"
export * from "./Metadata.vue?vue&type=script&lang=js"
import style0 from "./Metadata.vue?vue&type=style&index=0&id=21f13a35&prod&scoped=true&lang=css"
import style1 from "./Metadata.vue?vue&type=style&index=1&id=21f13a35&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f13a35",
  null
  
)

export default component.exports